
import { defineComponent, ref } from 'vue'
import { CreateAuctionForm, auctionFactory } from '../contracts/auctions-factory'
import tokens from '@/data/tokens.json'
import { createContractClient, refContract, Snip20Contract, snip20Def } from '@stakeordie/griptape.js';
import { formatAmountforToken } from '@/utils';
import { useRouter } from 'vue-router'

export default defineComponent({
    setup() {
        const router = useRouter();
        const form = ref<CreateAuctionForm>({
            sellContract: '',
            sellAmount: '',
            bidContract: '',
            minimumBid: '',
            endsAt: '',
            description: ''
        });

        const loading = ref(false);

        function createSellTokenClient() {
            const contractAddress = form.value.sellContract;
            console.log(contractAddress);
            createContractClient({
                id: contractAddress,
                at: contractAddress,
                definition: snip20Def
            }) 
        }

        async function createAuction() {
            const theForm = form.value;
            const sellContract = refContract<Snip20Contract>(theForm.sellContract);
            const sellAmount = formatAmountforToken(theForm.sellContract, theForm.sellAmount);
            loading.value = true;
            try {
                await sellContract.increaseAllowances(auctionFactory.at , sellAmount);
                await auctionFactory.createAuction(theForm);
            } finally {
                loading.value = false;
                router.push({ path: '/' });
            }
        }

        return {
            form,
            tokens,
            loading,
            createAuction,
            createSellTokenClient
        }
    }
})
